export enum SurveyQuestionFieldType {
  MultiAttachment = 'multi_attachment',
  Attachment = 'attachment',
  Boolean = 'boolean',
  Email = 'email',
  MultiOptions = 'multi_options',
  Options = 'options',
  Phone = 'phone',
  Rating = 'rating',
  Text = 'text',
  Url = 'url',
  Location = 'location',
}
